import clsx from 'clsx'
import React, { useEffect, useId, useState } from 'react'

export const Collapse = ({ title, active, titleClassName, defaultValue = false, onClick, disableIcon, children }) => {
  const id = useId()
  const [expand, setExpand] = useState(defaultValue)

  useEffect(() => {
    setExpand(defaultValue)
  }, [defaultValue])

  const displayIcon = () => {
    if (disableIcon) return null
    const iconClassName = expand ? 'fa-chevron-up' : 'fa-chevron-down'
    return (
      <span
        aria-controls={id}
        data-toggle="collapse"
        href={`#${CSS.escape(id)}`}
        aria-expanded={defaultValue}
        onClick={(e) => setExpand(!expand)}
      >
        <i className={clsx('fa-regular dome-color-darkest-grey fa-xs', iconClassName)}></i>
      </span>
    )
  }

  return (
    <div className="dome-d-flex dome-flex-column dome-gap3">
      <div
        onClick={onClick}
        aria-selected={active}
        className="toc-drawer-item-to-scroll dome-d-flex dome-gap6 dome-align-baseline dome-cursor-pointer"
      >
        <span className={clsx(titleClassName ?? 'dome-p2 dome-color-dark-grey dome-text-w500 dome-overflow-ellipsis')}>
          {title}
        </span>
        {displayIcon()}
      </div>
      <div className={`collapse ${defaultValue ? 'in' : ''}`} id={id}>
        {children}
      </div>
    </div>
  )
}

export const ScrollToItem = ({ id }) => {
  return (
    <div className="dome-relative">
      <div
        id={`scroll-item-${id}`}
        style={{ position: 'absolute', top: -200, visibility: 'hidden', pointerEvents: 'none' }}
      />
    </div>
  )
}

const TableOfContent = ({ packageRequirements, width, onSave = () => {}, onClose }) => {
  const [activeField, setActiveField] = useState()

  const getFieldId = (field) => field?.id ?? field?.client_id

  const handleSelectedField = (field) => {
    setActiveField(field)
    const scrollItem = document.getElementById(`scroll-item-${getFieldId(field)}`)
    scrollItem.scrollIntoView({ behavior: 'smooth' })
  }

  return (
    <div style={{ padding: '86px 36px 55px 36px', width: width, height: '100%' }}>
      <div style={{ top: 25, right: 25 }} onClick={onClose} className="dome-absolute dome-cursor-pointer">
        <i className="fa-sharp fa-light fa-xmark"></i>
      </div>
      <div className="dome-d-flex dome-flex-column dome-gap18">
        <div className="dome-d-flex dome-flex-column dome-gap6">
          <div className="dome-d-flex dome-justify-between dome-align-start">
            <span className="dome-h2 dome-color-darkest-grey">requirements</span>
            <button onClick={onSave} type="button" className="dome-btn dome-btn-base dome-btn-dark-green">
              save
            </button>
          </div>
          <span className="dome-p2 dome-color-med-grey">Select a requirement to jump to.</span>
        </div>
        <div style={{ height: 1, background: '#DBDBDB' }}></div>
        <Collapse id="toc-content" title="collapse all" defaultValue={true}>
          <div className="dome-d-flex dome-flex-column dome-gap3" style={{ marginTop: 15 }}>
            {packageRequirements?.map((field, index) => {
              const documents = field.package_template_documents
              const isActive = getFieldId(field) === getFieldId(activeField)
              const disableIcon = !documents?.length
              const stt = index + 1
              return (
                <Collapse
                  key={getFieldId(field)}
                  active={isActive}
                  disableIcon={disableIcon}
                  title={`${stt}. ${field.title}`}
                  titleClassName="toc-drawer-item-to-scroll-title"
                  onClick={() => handleSelectedField(field)}
                >
                  <div className="dome-d-flex dome-flex-column dome-gap3">
                    {documents?.map((document) => {
                      return (
                        <div key={document.id} className="toc-drawer-item-document">
                          <span className="dome-p1 dome-color-med-grey two-row-text">{document.resource_name}</span>
                        </div>
                      )
                    })}
                  </div>
                </Collapse>
              )
            })}
          </div>
        </Collapse>
      </div>
    </div>
  )
}

export default TableOfContent
